/*****************************************************************************
 * Open MCT, Copyright (c) 2014-2020, United States Government
 * as represented by the Administrator of the National Aeronautics and Space
 * Administration. All rights reserved.
 *
 * Open MCT is licensed under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations
 * under the License.
 *
 * Open MCT includes source code licensed under additional open source
 * licenses. See the Open Source Licenses file (LICENSES.md) included with
 * this source code distribution or the Licensing information page available
 * at runtime from the About dialog for additional information.
 *****************************************************************************/

/**
 * Module defining PartialConstructor. Created by vwoeltje on 11/3/14.
 */
define(
    [],
    function () {

        /**
         * A partial constructor is used to instantiate objects in two
         * stages:
         *
         * * First, dependencies injected from Angular
         * * Second, arguments passed at run-time
         *
         * This allows extensions to accept both their Angular-injected
         * dependencies and their per-instance attributes all in one
         * constructor invocation. User code for these extensions then
         * does not see the Angular dependency arguments; they may
         * instantiate instances of these extensions by passing only
         * those per-instance arguments.
         *
         * @memberof platform/framework
         * @constructor
         */
        function PartialConstructor(Constructor) {

            function OuterConstructor() { // Bind services
                var dependencies = Array.prototype.slice.call(arguments);

                function InnerConstructor() { // Bind everything else
                    var other = Array.prototype.slice.call(arguments),
                        instance = Object.create(Constructor.prototype);

                    // Mimic "new" behavior with apply.
                    instance = Constructor.apply(
                        instance,
                        dependencies.concat(other)
                    ) || instance;

                    return instance;
                }

                // Copy properties from original constructor
                Object.keys(Constructor).forEach(function (k) {
                    InnerConstructor[k] = Constructor[k];
                });

                return InnerConstructor;
            }

            return OuterConstructor;
        }

        return PartialConstructor;
    }
);
